export const products = [
  {
    id: 1,
    img: "facebook.png",
    link: "https://sanjiv-facebook.web.app/",
  },
  {
    id: 2,
    img: "memories-blog.png",
    link: "https://sanjiv-memories-blog.web.app/",
  },
  {
    id: 3,
    img: "Blog-Web.png",
    link: "https://sanjiv-s-blog-website.web.app/",
  },
  {
    id: 4,
    img: "whatsapp-mern.png",
    link: "https://whatsapp-mern-ae0af.web.app/",
  },
  {
    id: 5,
    img: "netflix-webpage.png",
    link: "https://netflix-clone-90ee3.web.app/",
  },
  {
    id: 6,
    img: "tesla-clone.png",
    link: "https://tesla-clone-a07e7.web.app/",
  },
  {
    id: 7,
    img: "covid19-tracker.png",
    link: "https://covid-19-tracker-8eba4.web.app/",
  },
  {
    id: 8,
    img: "clubhouse-clone.png",
    link: "https://clubhouse-clone-dd2cb.web.app/",
  },
  {
    id: 9,
    img: "tiktok-clone.png",
    link: "https://tiktok-clone-80f96.web.app/",
  },
];
